import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  recoverPasswordForm: FormGroup;
  successMessage: string | null = null;
  errorMessage: string | null = null;

  constructor(private authService: AuthenticationService) {}

  ngOnInit() {
    this.recoverPasswordForm = new FormGroup({
      email: new FormControl('')
    });
  }

  async onRecoverPassword() {
    const email = this.recoverPasswordForm.value.email;
    try {
      await this.authService.resetPassword(email);
      this.successMessage = 'Recovery email sent.';
      this.errorMessage = null;
    } catch (err) {
      console.error('Password reset failed:', err);
      this.errorMessage = 'Failed to send reset email. Please try again.';
      this.successMessage = null;
    }
  }
}
